import { useEffect, useState } from 'react';

export default function usePreloadedFullscreenImage(
  source: string,
  { disabled } = { disabled: false },
) {
  const [resultSource, setResultSource] = useState(source);

  useEffect(() => {
    if (disabled) return;
    const fullscreenSrc = source.replace('/images/preload/', '/images/');
    fetch(fullscreenSrc, { mode: 'no-cors' }).then(() =>
      setResultSource(fullscreenSrc),
    );
  }, [source, disabled]);

  return resultSource;
}
